import Component from '@glimmer/component';

interface HeaderNavArgs {}

export default class HeaderNavComponent extends Component<HeaderNavArgs> {}
